import { AccountingPeriodRecord } from '../../../../types/accounting';

export interface AccountingPeriodFormState {
  name: string;
  outletId: string | null;
  periodStart: string;
  periodEnd: string;
  notes: string;
}

export const createEmptyAccountingPeriodForm = (
  defaults?: Partial<AccountingPeriodFormState>,
): AccountingPeriodFormState => ({
  name: '',
  outletId: null,
  periodStart: '',
  periodEnd: '',
  notes: '',
  ...defaults,
});

export const createAccountingPeriodFormFromRecord = (
  period: AccountingPeriodRecord,
): AccountingPeriodFormState => ({
  name: period.name,
  outletId: period.outlet_id,
  periodStart: period.period_start,
  periodEnd: period.period_end,
  notes: period.notes ?? '',
});
